import { styled, withStyle } from "baseui";
import { Skeleton } from "baseui/skeleton";

const SkeletonContainer = styled('div', {
  width: '100%',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  overflow: 'hidden',
});

const SearchBarSkeleton = styled('div', {
  padding: '16px',
  backgroundColor: '#f3f4f6',
});

const SkeletonRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: '15% 20% 15% 10% 15% 20% 5%',
  padding: '16px',
  gap: '16px',
  borderBottom: '1px solid #f3f4f6',
  alignItems: 'center',
  backgroundColor: '#ffffff',
  ':nth-child(even)': {
    backgroundColor: '#f9fafb',
  },
});

const HeaderRow = withStyle(SkeletonRow, {
  backgroundColor: '#ffffff',
  borderBottom: '1px solid #e5e7eb',
  fontWeight: 500,
});

const SkeletonCell = styled(Skeleton, {
  height: '20px',
  borderRadius: '4px',
});

interface TableSkeletonProps {
  rows?: number;
  /** Only the rows: for a list that already draws its own search bar and header (the Business tabs). */
  bare?: boolean;
  /** Read out by screen readers in place of the grey rows. */
  label?: string;
}

export const TableSkeleton = ({ rows = 4, bare = false, label }: TableSkeletonProps) => {
  return (
    <SkeletonContainer role="status" aria-busy="true" aria-label={label}>
      {!bare && (<>
      <SearchBarSkeleton>
        <SkeletonCell
          width="300px"
          height="40px"
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.06)',
              },
            },
          }}
        />
      </SearchBarSkeleton>

      <HeaderRow>
        <SkeletonCell
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            },
          }}
        />
        <SkeletonCell
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            },
          }}
        />
        <SkeletonCell
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            },
          }}
        />
        <SkeletonCell
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            },
          }}
        />
        <SkeletonCell
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            },
          }}
        />
        <SkeletonCell
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            },
          }}
        />
        <SkeletonCell
          animation
          overrides={{
            Root: {
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            },
          }}
        />
      </HeaderRow>
      </>)}

      {Array(rows)
        .fill(0)
        .map((_, rowIndex) => (
          <SkeletonRow key={`row-${rowIndex}`}>
            <SkeletonCell
              animation
              overrides={{
                Root: {
                  style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
              }}
            />
            <SkeletonCell
              animation
              overrides={{
                Root: {
                  style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
              }}
            />
            <SkeletonCell
              animation
              overrides={{
                Root: {
                  style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
              }}
            />
            <SkeletonCell
              animation
              overrides={{
                Root: {
                  style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
              }}
            />
            <SkeletonCell
              animation
              overrides={{
                Root: {
                  style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
              }}
            />
            <SkeletonCell
              animation
              overrides={{
                Root: {
                  style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
              }}
            />
            <SkeletonCell
              animation
              overrides={{
                Root: {
                  style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                },
              }}
            />
          </SkeletonRow>
        ))}
    </SkeletonContainer>
  );
}; 